import Chip from '@mui/material/Chip'
import { styled } from '@mui/material/styles'

import type { FilterChipProps } from './FilterChipSquarish'

export const StyledFilterChipSquarish = styled(Chip)<FilterChipProps>(
  ({ theme, selected, icon }) => ({
    '&.MuiChip-root': {
      backgroundColor: selected
        ? theme.palette.action['bg-selected']
        : theme.palette.background.surface,
      border: `1px solid ${theme.palette.border.subtle}`,
      borderRadius: '8px',
      height: theme.spacing(4),

      '&:hover': {
        borderColor: theme.palette.border.info,
      },
      '&:focus-visible': {
        border: `2px solid ${theme.palette.border.focus}`,
      },
    },

    '& .MuiChip-label': {
      color: theme.palette.text.primary,
      fontWeight: 400,
      padding: '4px 8px',
      ...(icon && { paddingLeft: theme.spacing(1) }),
      fontSize: '14px',
    },
    '& .MuiChip-icon': {
      color: theme.palette.text.primary,
    },
  }),
)
